import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const ScrollWrapper = styled.div`
  overflow-y: scroll;
`

export const ModalHead = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  border-top: 1px solid ${({ theme }) => theme.mocaLtGrey};
  padding: 24px 12px;
  max-height: calc(44vw - 120px);
  overflow-y: auto;

  @media (max-width: 1024px) {
    max-height: calc(60vw - 120px);
  }

  @media (max-width: 768px) {
    max-height: calc(80vw - 120px);
  }

  @media (max-width: 640px) {
    max-height: calc(80vh - 120px);
  }
`

export const InputRow = styled.div`
  flex: 7;
  display: flex;
  flex-direction: column;
`

export const ViewPositionRow = styled.div.attrs({
  className: `row col-7 px-0 pr-2 mx-0`
})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const SectionRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 960px) {
    max-width: 500px;
  }
`

export const ModalFooter = styled.div.attrs({
  className: `row col-12 px-0 mx-0 my-3`
})`
  display: flex;
  flex-direction: row;
  justify-content: ${({ pos }) => (pos === 'l' ? 'flext-start' : pos === 'c' ? 'center' : 'flex-end')};
`

export const CheckboxWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  font-size: 12px;
`

export const RequiredSign = styled.span`
  color: red;
  font-size: 12px;
  margin-right: auto;
  align-self:  ${({ pos }) => (pos === 'c' ? 'center' : 'start')};;
`
